// @ts-strict-ignore
import buildDependencies from '../dependencies';
import {
  transformBooleanRuleAndDataRoutesInActions,
  transformLegacyActionsToJsonRepresentation,
} from './actions';
import { transformLegacyThresholdsToJsonRepresentation } from './thresholds';
import { transformLegacyDataRoutesToJsonRepresentation } from './dataRoutes/dataRoutes';
import type { Services, ServicesByName } from '../types';

export function transformLegacyRepresentationToJson({
  actions,
  actionOptions,
  customLists,
  dataRoutes,
  lists,
  matrixModels,
  outcomes,
  publishedAttributes,
  reasonCodeGroups,
  services,
  snippets,
  tags,
  thresholds,
  universalAttributes = {},
}) {
  const {
    transformedActionsWithoutRules,
    legacyActionsTransformationMap,
    issuesWithTransformedJsonActions,
  } = transformLegacyActionsToJsonRepresentation({
    actions,
    actionOptions,
    tags,
    services,
    outcomes,
    publishedAttributes,
    matrixModels,
    lists,
    customLists,
    snippets,
  });
  const {
    transformedThresholds,
    legacyThresholdsTransformationMap,
    issuesWithTransformedJsonThresholds,
  } = transformLegacyThresholdsToJsonRepresentation({
    thresholds,
    transformedActions: transformedActionsWithoutRules,
    services,
    legacyActionsToTransformedActionsIdMap: legacyActionsTransformationMap.relativeIds,
    reasonCodeGroups,
    universalAttributes,
  });
  const {
    transformedDataRoutes,
    legacyDataRoutesTransformationMap,
  } = transformLegacyDataRoutesToJsonRepresentation({
    dataRoutes,
    transformedActions: transformedActionsWithoutRules,
    services,
    legacyActionsToTransformedActionsIdMap: legacyActionsTransformationMap.relativeIds,
    universalAttributes,
  });
  const transformedActionsWithRules = transformBooleanRuleAndDataRoutesInActions({
    transformedActionsWithoutRules,
    legacyToTransformedThresholdIdMap: legacyThresholdsTransformationMap,
    legacyDataRoutesToTransformedDataRoutesIdMap: legacyDataRoutesTransformationMap,
  });


  const dependencies = buildDependencies({
    actions: transformedActionsWithRules,
    dataRoutes: transformedDataRoutes,
    thresholds: transformedThresholds,
  });

  const validations = {
    timestamp: Date.now(),
    actions: issuesWithTransformedJsonActions,
    thresholds: issuesWithTransformedJsonThresholds,
  };

  return {
    actions: transformedActionsWithRules,
    thresholds: transformedThresholds,
    dataRoutes: transformedDataRoutes,
    dependencies,
    validations,
    legacyMappings: {
      actions: legacyActionsTransformationMap.absoluteIds,
      thresholds: legacyThresholdsTransformationMap,
    },
  };
}

export function keyServicesObjectByInternalName(services: Services): ServicesByName {
  return Object.entries(services).reduce((newServices, [, serviceObj]) => ({
    ...newServices, [serviceObj.internal_name]: serviceObj,
  }), {});
}
